export const CONTACT_LIST = {
    LiveChat: 'LiveChat',
    Phone: 'Phone',
    WhatsApp: 'WhatsApp',
    WeChat: 'WeChat',
    Skype: 'Skype',
    Yahoo: 'Yahoo',
    BBM: 'BBM',
    Telegram: 'Telegram',
    Email: 'Email',
    Zalo: 'Zalo',
    Facebook: 'Facebook',
    Instagram: 'Instagram',
    Line: 'Line',
    QRCode: 'QRCode',
    Twitter: 'Twitter',
    Youtube: 'Youtube',
};

export const ADDITIONAL_CONTACT_LIST = {
    Website: 'Website',
    Affiliate: 'Affiliate',
};

export const GAME_CATEGORY = {
    CASINO: 'Casino',
    SLOT: 'Slot',
    SPORTS: 'Sportsbook',
    ESPORTS: 'ESportsbook',
    ESPORTS2: 'Esport',
    FISHING: 'Fishing',
    LOTTERY: 'Lottery',
    GAME: 'Games',
    POKER: 'Poker',
    RACING: 'Racing',
    FOURD: 'FourD',
    COCKFIGHT: 'Cockfight',
    FASTGAMES: 'FastGames',
    BINGO: 'Bingo',
};

// NOTE: FOLLOW BACKEND DATA CATEGORY ONE, NOT BASE MENU.
export const PROVIDER_CATEGORY = {
    SLOT: 'SLOT',
    FISHING: 'FISHING',
    GAME: 'TABLE',
    LOTTERY: 'LOTTERY',
    POKER: 'POKER',
    SPORTSBOOK: 'SPORTS',
    ESPORTSBOOK: 'ESportsbook',
    FOURD: 'FD',
    TOGEL: 'LOTTERY',
    FASTGAMES: 'FAST',
    FAST: 'FASTGAMES',
    BINGO: 'BINGO',
};

export const PRODUCT_PAGE = {
    CASINO: 'C',
    SLOT: 'SL',
    FASTGAMES: 'FG',
    LEADERBOARD: 'LB',
    HOME: 'H',
    TOP: 'TP',
};

export const PROVIDER_CATEGORY_PREFIX = {
    CASINO: 'C',
    SLOT: 'SL',
    SLOTS: 'SL',
    SPORTS: 'S',
    SPORTSBOOK: 'S',
    ESPORTSBOOK: 'ES',
    ESPORTS: 'ES',
    FISHING: 'F',
    FISH: 'F',
    LOTTERY: 'L',
    GAMES: 'G',
    POKER: 'P',
    RACING: 'RC',
    COCKFIGHT: 'CF',
    FOURD: 'FD',
    TOGEL: 'T',
    FASTGAMES: 'FG',
    BINGO: 'BG',
    FAST: 'FG',
    EXCHANGE: 'EC',
    LIVEGAMES: 'LG',
    TVGAMES: 'TG',
    TVGAME: 'TVG', // for Product Banner
    LEADERBOARD: 'LB',
};

export const PROVIDER_CATEGORY_PREFIX_WALLET_BETA = [
    {
        prefix: PROVIDER_CATEGORY_PREFIX.SPORTSBOOK,
        key: 'sportbook',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.ESPORTSBOOK,
        key: 'esport',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.CASINO,
        key: 'casino',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.SLOT,
        key: 'slots',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.FISHING,
        key: 'fishing',
    },

    {
        prefix: PROVIDER_CATEGORY_PREFIX.GAMES,
        key: 'games',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.LOTTERY,
        key: 'lottery',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.FASTGAMES,
        key: 'fastgames',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.POKER,
        key: 'poker',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.RACING,
        key: 'others',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.COCKFIGHT,
        key: 'cockfight',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.LIVEGAMES,
        key: 'livegames',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.FOURD,
        key: 'fourD',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.TOGEL,
        key: 'togel',
    },
    {
        prefix: PROVIDER_CATEGORY_PREFIX.BINGO,
        key: 'bingo',
    },
];

export const ROUTE_PATH = {
    PROFILE: '/myaccount/profile',
};

export const PAYMENT_GATEWAY_SETTING = {
    amountFieldNotRequired: 'amountFieldNotRequired',
    hasSpecialImportantNotice: 'hasSpecialImportantNotice',
    hasCardInfo: 'hasCardInfo',
};

export const CMS_BANK_IMAGE_PATH = '/cms/public/payment/icons/Bank';
export const CMS_PAYMENT_METHOD_IMAGE_PATH = '/cms/public/payment/icons/Payment_Method';
export const CMS_PAYMENT_GATEWAY_IMAGE_PATH = '/cms/public/payment/icons/Payment_Gateway';

export const PROMOTION_TYPE = {
    VIP: 'VIP',
    VIP_BONUS: 'VIP BONUS',
    NEW_MEMBER: 'NEW_MEMBER',
    NORMAL_MEMBERS: 'NORMAL_MEMBERS',
    WINNER: 'WINNER',
    REBATE: 'REBATE',
    FREEBET: 'FREEBET',
    PROVIDER_EVENT: 'PROVIDER_EVENT',
    SPECIAL: 'SPECIAL',
    SPORTSBOOK: 'SPORTSBOOK',
    CASINO: 'CASINO',
    SLOT: 'SLOT',
    LOTTERY: 'LOTTERY',
    GAMES: '3D GAMES',
    FISHING: 'FISHING',
    ESPORT: 'ESPORT',
    VIRTUAL_SPORT: 'VIRUAL SPORT', // WHY THE RESPONSE SPELT VIRUAL?
    CRYPTO: 'CRYPTO',
};

export const HOTMATCH_SPORTS_ID = {
    SOCCER: '1',
    BASKETBALL: '2',
};

export const SCROLL_TO_ID = 'provider-box';

/**
 * NOTE: currently use in beta only
 * page = on page enter / event = on action
 */
export const AD_ELEMENT_EVENT = {
    HOME_PAGE: 'aeHomePage',
    PRODUCT_PAGE: 'aeProductPage',
    JOIN_NOW_PAGE: 'aeJoinNowPage',
    REGISTER_EVENT: 'aeRegisterEvent',
    REGISTER_SUCCESS_PAGE: 'aeRegisterSuccessPage',
    LOGIN_PAGE: 'aeLoginPage',
    LOGIN_EVENT: 'aeLoginEvent',
    DEPOSIT_PAGE: 'aeDepositPage',
    DEPOSIT_EVENT: 'aeDepositEvent',
    DEPOSIT_SUCCESS_EVENT: 'aeDepositSuccessEvent',
};

export const AD_ELEMENT_PRODUCT_CATEGORY_NAME = {
    CASINO: 'casino',
    SLOT: 'slot',
    SPORTSBOOK: 'sports', // same as esport
    ESPORTSBOOK: 'sports', // same as sport
    FISHING: 'fishing',
    LOTTERY: 'lottery',
    GAMES: 'games',
    POKER: 'poker',
    FOURD: '4d',
    FASTGAMES: 'fastgames',
    BINGO: 'bingo',
};

/** Register Constant */
export const REG_FIELD = {
    USERNAME: 'username',
    AFFILIATE: 'affiliateid',
    FULL_NAME: 'fullname',
    FIRST_NAME: 'firstname',
    LAST_NAME: 'lastname',
    CURRENCY: 'currency',
    EMAIL: 'email',
    PASSWORD: 'password',
    CONFIRM_PASSWORD: 'confirmPassword',
    PHONE: 'phone',
    TELCODE: 'telCode',
    SEND_OTP_TO: 'send_otp_to',
    DOB: 'dob',
    GENDER: 'gender',
    OTHER_CONTACT: 'otherContact',
    OTHER_BANK: 'otherBank',
    BANK: 'bank',
    BANK_ACC_NO: 'bankAccNo',
    REFERRAL_SOURCE: 'referralSource',
    REFERRAL_OTHER_SOURCE: 'referralOtherSource',
    CONDITION_CHECK: 'conditionCheck',
    CHECK_OFFER: 'checkOffer',
    OTP_CODE: 'otpCode',
    COUNTRY_BANK: 'countryBank',
    PREFERRED_CURRENCY: 'preferredCurrency',
    PREFERRED_CURRENCY_LABEL: 'preferredCurrencyLabel',
    AUTH_OTP: 'authOTP',
    CAPTCHA_TOKEN: 'captchaToken',
    CURRENT_PASSWORD: 'currentPassword',
    CRYPTO_ADDRESS: 'cryptoAddress',
};

export const GAME_TYPE = {
    HOT: 'HOT',
    NEW: 'NEW',
};

export const REFERRAL_COLUMN_FIELD = {
    activeMember: {
        textKey: 'transaction:transaction.referral.activeMember',
        fallback: 'Active Member',
    },
    approvedDate: {
        textKey: 'transaction:transaction.referral.approvedDate',
        fallback: 'Approved Date',
    },
    bonusAmount: {
        textKey: 'settings:settings.bonusAmount',
        fallback: 'Bonus Amount',
    },
    commAmount: {
        textKey: 'transaction:transaction.referral.commAmount',
        fallback: 'Comm Amount',
    },
    commRate: {
        textKey: 'transaction:transaction.referral.commRate',
        fallback: 'Comm Rate',
    },
    commType: {
        textKey: 'transaction:transaction.referral.commType',
        fallback: 'Comm Type',
    },
    contributor: {
        textKey: 'referral:referral.contributor',
        fallback: 'Contributor',
    },
    currency: {
        textKey: 'settings:settings.currency',
        fallback: 'Currency',
    },
    downline: {
        textKey: 'referral:referral.myTeamTable.downline',
        fallback: 'Downline',
    },
    endTime: {
        textKey: 'transaction:transaction.referral.end',
        fallback: 'End Date',
    },
    forfeitedAmount: {
        textKey: 'transaction:transaction.referral.forfeitedAmount',
        fallback: 'Forfeited Amount',
    },
    memberLogin: {
        textKey: 'settings:settings.memberLogin',
        fallback: 'Member Login',
    },
    product: {
        textKey: 'referral:referral.myrewards.product',
        fallback: 'Product',
    },
    provider: {
        textKey: 'transaction:transaction.history.provider',
        fallback: 'Provider',
    },
    referrer: {
        textKey: 'referral:referral.myTeamTable.referrer',
        fallback: 'Referrer',
    },
    registerTime: {
        textKey: 'settings:settings.registerTime',
        fallback: 'Receive Time',
    },
    status: {
        textKey: 'settings:settings.status',
        fallback: 'Status',
    },
    startTime: {
        textKey: 'transaction:transaction.referral.start',
        fallback: 'Start Date',
    },
    tier: {
        textKey: 'settings:settings.tier',
        fallback: 'Tier',
    },
    totalDeposit: {
        textKey: 'settings:settings.totalDeposit',
        fallback: 'Total Deposit',
    },
    totalEligibleTurnover: {
        textKey: 'transaction:transaction.history.totalEligibleTurnOver',
        fallback: 'Total Eligible Turn Over',
    },
    totalPromoTurnover: {
        textKey: 'transaction:transaction.history.totalPromoTurnOver',
        fallback: 'Total Promo Turn Over',
    },
    totalValidTurnover: {
        textKey: 'transaction:transaction.history.totalValidTurnOver',
        fallback: 'Total Valid Turn Over',
    },
    totalWinLoss: {
        textKey: 'transaction:transaction.referral.winLose',
        fallback: 'Total Win Loss',
    },
    transactionDate: {
        textKey: 'transaction:transaction.history.transactionDate',
        fallback: 'Transaction Date',
    },
};

/** Gender Constant */
export const GENDER_OPTION = {
    genderOption: [
        {
            key: '',
            display: 'global:global.form.Select2',
            default: 'Select',
        },
        {
            key: 'M',
            display: 'global:global.form.male',
            default: 'Male',
        },
        {
            key: 'F',
            display: 'global:global.form.female',
            default: 'Female',
        },
    ],
};

/* payment method type */
export const PAYMENT_ID_TYPE = {
    CPF: 'CPF',
    CNPJ: 'CNPJ',
    NORMAL: 'NORMAL',
};

export const REGION = {
    BRAZIL: 'BRL',
};

export const E_WALLET_BANK_DETAILS_ACCOUNT_TYPE = {
    ACCOUNT_NUMBER: 1,
    CPF_NUMBER: 2,
    CNPJ_NUMBER: 3,
};

export const CONTRIBUTION_MODAL_FIELD = {
    memberLogin: { textKey: 'settings:settings.memberLogin', fallback: 'Member Login' },
    referrer: { textKey: 'referral:referral.myTeamTable.referrer', fallback: 'Referrer' },
    tier: { textKey: 'referral:referral.myTeamTable.tier', fallback: 'Tier' },
    downline: { textKey: 'referral:referral.myTeamTable.downline', fallback: 'Downline' },
    provider: { textKey: 'transaction:transaction.history.provider', fallback: 'Provider' },
    product: { textKey: 'referral:referral.myrewards.product', fallback: 'Product' },
    currency: { textKey: 'settings:settings.currency', fallback: 'Currency' },
    totalValidTurnOver: { textKey: 'transaction:transaction.history.totalValidTurnOver', fallback: 'Total Valid Turn Over' },
    totalPromoTurnOver: { textKey: 'transaction:transaction.history.totalPromoTurnOver', fallback: 'Total Promo Turn Over' },
    totalEligibleTurnOver: { textKey: 'transaction:transaction.history.totalEligibleTurnOver', fallback: 'Total Eligible Turn Over' },
    totalWinLoss: { textKey: 'transaction:transaction.referral.winLose', fallback: 'Total Win Loss' },
    forfeitedAmount: { textKey: 'transaction:transaction.referral.forfeitedAmount', fallback: 'Forfeited Amount' },
    commAmount: { textKey: 'transaction:transaction.referral.commAmount', fallback: 'Comm Amount' },
    rate: { textKey: 'transaction:transaction.referral.rate', fallback: 'Rate' },
};

export const menuGroup = {
    game: 'game',
    userEngagement: 'userEngagement',
    liveGame: 'livegame',
    perk: 'perk',
    contact: 'contact',
    sideMenu: 'sideContent',
    account: 'account',
};

export const specialMenuMapping = {
    mobile: 'download',
    sportsbook: 'sports',
    'sports-landing': 'sports',
    esportsbook: 'esports',
    'esports-landing': 'esports',
    'casino-landing': 'casino',
    'slots-landing': 'slot',
    psy8: 'slot',
    slots: 'slot',
    'poker-landing': 'poker',
    'lottery-landing': 'lottery',
    'games-landing': 'games',
    'racing-landing': 'racing',
    promotions: 'promotion',
    fish: 'fishing',
    'ambassador-home': 'ambassador',
    'cockfight-landing': 'cockfight',
};

export const OTP_CONTACT_TYPE = {
    PHONE: 'PHONE',
    EMAIL: 'EMAIL',
    QQ: 'QQ',
    CRYPTO: 'CRYPTO',
    SMS_VERIFICATION_BY_MEMBER: 'SMS_VERIFICATION_BY_MEMBER',
    GOOGLE_OTP: 'GOOGLE_OTP',
    WECHAT: 'WECHAT',
    CRYPTO_EMAIL_AUTH: 'CRYPTO_EMAIL_AUTH',
    ZALO: 'ZALO',
    WHATSAPP: 'WHATSAPP',
    LINE: 'LINE',
    TELEGRAM: 'TELEGRAM',
    SKYPE: 'SKYPE',
    EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
    SMS_VERIFICATION: 'SMS_VERIFICATION',
    WITHDRAW_PIN: 'WITHDRAW_PIN',
};

export const OTP_VERIFICATION_TYPE = {
    BIND_AUTHENTICATOR: 'BIND_AUTHENTICATOR',
    LOGIN: 'LOGIN',
    REGISTRATION: 'REGISTRATION',
    EXTERNAL_REGISTRATION: 'EXTERNAL_REGISTRATION',
    RESET_PASSWORD: 'RESET_PASSWORD',
    AFF_RESET_PASSWORD: 'AFF_RESET_PASSWORD',
    USER_VERIFICATION: 'USER_VERIFICATION',
    UPDATE_MEMBER_INFO: 'UPDATE_MEMBER_INFO',
    CRYPTO_ADDRESS: 'CRYPTO_ADDRESS',
    WITHDRAWAL_BANK: 'WITHDRAWAL_BANK',
    WITHDRAWAL_CRYPTO: 'WITHDRAWAL_CRYPTO',
    WITHDRAWAL_EWALLET: 'WITHDRAWAL_EWALLET',
    WITHDRAWAL_P2PW: 'WITHDRAWAL_P2PW',
    BANK_DETAIL_BANK: 'BANK_DETAIL_BANK',
    BANK_DETAIL_CRYPTO: 'BANK_DETAIL_CRYPTO',
    BANK_DETAIL_EWALLET: 'BANK_DETAIL_EWALLET',
    AFF_WITHDRAWAL_BANK: 'AFF_WITHDRAWAL_BANK',
    AFF_WITHDRAWAL_CRYPTO: 'AFF_WITHDRAWAL_CRYPTO',
    AFF_WITHDRAWAL_WIRE_TRANSFER: 'AFF_WITHDRAWAL_WIRE_TRANSFER',
    AFF_WITHDRAWAL_EWALLET: 'AFF_WITHDRAWAL_EWALLET',
    AFF_CRYPTO_ADDRESS: 'AFF_CRYPTO_ADDRESS',
    AFF_BANK_DETAIL_BANK: 'AFF_BANK_DETAIL_BANK',
    AFF_BANK_DETAIL_WIRE: 'AFF_BANK_DETAIL_WIRE',
    SIX_PIN: 'SIX_PIN',
    AFF_SIX_PIN: 'AFF_SIX_PIN',
    CLOUDFLARE_TURNSTILE: 'CLOUDFLARE_TURNSTILE',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    AFF_RETRIEVE_USERNAMES: 'AFF_RETRIEVE_USERNAMES',
};

export const OTP_VERIFICATION_METHOD = {
    WHATSAPP: 'WHATSAPP',
    PHONE: 'PHONE',
    EMAIL: 'EMAIL',
    GA: 'GA',
    OTP: 'OTP',
    SIX_PIN: 'SIX_PIN',
};

export const MODULE_TYPE = {
    BIND_AUTHENTICATOR: 'BIND_AUTHENTICATOR',
    AFF_BIND_AUTHENTICATOR: 'AFF_BIND_AUTHENTICATOR',
    LOGIN: 'LOGIN',
    REGISTRATION: 'REGISTRATION',
    EXTERNAL_REGISTRATION: 'EXTERNAL_REGISTRATION',
    RESET_PASSWORD: 'RESET_PASSWORD',
    AFF_RESET_PASSWORD: 'AFF_RESET_PASSWORD',
    USER_VERIFICATION: 'USER_VERIFICATION',
    UPDATE_MEMBER_INFO: 'UPDATE_MEMBER_INFO',
    CRYPTO_ADDRESS: 'CRYPTO_ADDRESS',
    WITHDRAWAL_BANK: 'WITHDRAWAL_BANK',
    WITHDRAWAL_CRYPTO: 'WITHDRAWAL_CRYPTO',
    WITHDRAWAL_EWALLET: 'WITHDRAWAL_EWALLET',
    BANK_DETAIL_BANK: 'BANK_DETAIL_BANK',
    BANK_DETAIL_CRYPTO: 'BANK_DETAIL_CRYPTO',
    BANK_DETAIL_EWALLET: 'BANK_DETAIL_EWALLET',
    AFF_WITHDRAWAL_BANK: 'AFF_WITHDRAWAL_BANK',
    AFF_WITHDRAWAL_CRYPTO: 'AFF_WITHDRAWAL_CRYPTO',
    AFF_WITHDRAWAL_WIRE_TRANSFER: 'AFF_WITHDRAWAL_WIRE_TRANSFER',
    AFF_CRYPTO_ADDRESS: 'AFF_CRYPTO_ADDRESS',
    AFF_BANK_DETAIL_BANK: 'AFF_BANK_DETAIL_BANK',
    AFF_BANK_DETAIL_WIRE: 'AFF_BANK_DETAIL_WIRE',
    SIX_PIN: 'SIX_PIN',
    AFF_SIX_PIN: 'AFF_SIX_PIN',
    CLOUDFLARE_TURNSTILE: 'CLOUDFLARE_TURNSTILE',
    AFF_LOGIN: 'AFF_LOGIN',
    AFF_RETRIEVE_USERNAMES: 'AFF_RETRIEVE_USERNAMES',
    AFF_REGISTRATION: 'AFF_REGISTRATION',
    AFF_HEADER: 'AFF_HEADER',
    AFF_DEPOSIT_BANK: 'AFF_DEPOSIT_BANK',
    AFF_DEPOSIT_CRYPTO: 'AFF_DEPOSIT_CRYPTO',
    AFF_DEPOSIT_QUICK_PAY: 'AFF_DEPOSIT_QUICK_PAY',
    AFF_TRANSFER: 'AFF_TRANSFER',
};

export const MASTER_SWITCH_MODULE_TYPE = {
    VIP_SYSTEM: 'VIP_SYSTEM',
    LUCKY_WHEEL: 'LUCKY_WHEEL',
    INSTANT_REBATE: 'INSTANT_REBATE',
    SEAMLESS_WALLET: 'SEAMLESS_WALLET',
};

export const RESET_PASSWORD_FIELD = {
    EMAIL: 'email',
    PHONE: 'phone',
    LOGIN: 'login',
    OTP: 'otp',
    NEW_PASSWORD: 'newPassword',
    CONFIRM_PASSWORD: 'confirmPassword',
};

export const CRYPTO_ADDRESS_FIELD = {
    COIN: 'coin',
    NETWORK: 'network',
    ADDRESS: 'address',
    OTP: 'otp',
};

export const CONTACT_VERIFICATION_SINGLE_LAYER = ['EMAIL'];

export const SOCIAL_EXTERNAL_PROVIDER = {
    WHATSAPP: 'WHATSAPP',
    TELEGRAM: 'TELEGRAM',
    GOOGLE: 'GOOGLE',
    LINE: 'LINE',
    FACEBOOK: 'FACEBOOK',
};

export const CONTACT_VERIFICATION_METHODS = {
    PHONE: ['PHONE', 'WHATSAPP'],
    EMAIL: ['EMAIL'],
};

export const NON_SOCIAL_MEDIA = 'NON_SOCIAL_MEDIA';

export const DEPOSIT_GROUP_MAPPING = {
    depositMethod: 'group1',
    thirdPartyBankOptions: 'group2',
    depositOptions: 'group2',
    depositChannel: 'group1',
};

export const VPN_ICON_TEMPLATE_MODULE = {
    providerLanding: 'provider-landing',
    submenu: 'submenu',
};

export const DEPOSIT_BREADCRUMB_NAME = {
    myaccount: 'settings:settings.header',
    deposit: 'global:global.breadcums.deposit',
    withdraw: 'global:global.breadcums.withdraw',
    transfer: 'global:global.breadcums.transfer',
    'true-money-qr': 'True Money QR',
    'quick-pay': 'transaction:transaction.deposittab.quickPay',
    crypto: 'transaction:transaction.deposit.crypto.tab',
    'p2p-transfer': 'transaction:transaction.deposittab.p2p',
    'mobile-card': 'transaction:transaction.deposittab.mobileCard',
    'qrcode-pay': 'transaction:transaction.deposittab.qrpay',
    'bank-qr': 'transaction:transaction.deposit.bankQR.tab',
};

export const THEME_TOKENS = {
    vip: 'vip',
    'lucky-wheel': 'lucky-wheel',
    default: 'default',
};

export const PROVIDER_CATEOGRY_PREFIX = {
    fishing: 'F',
    slot: 'SL',
    lottery: 'L',
    games: 'G',
    sports: 'S',
    esport: 'ES',
    casino: 'C',
    cockfight: 'CF',
    poker: 'P',
    fastgames: 'FG',
    fourd: 'FD',
};

export const POPUP_TYPE = {
    DEPOSIT_PAYMENT_QR: 'DEPOSIT_PAYMENT_QR',
    GAME_MAINTENANCE: 'GAME_MAINTENANCE',
    FORGET_USERNAME: 'FORGET_USERNAME',
    UNBIND_GA: 'UNBIND_GA',
    ANNOUNCEMENT: 'ANNOUNCEMENT',
    MULTI_ANNOUNCEMENT: 'MULTI_ANNOUNCEMENT',
    PROMO_CODE_DETAIL: 'PROMO_CODE_DETAIL',
    UNREAD_MESSAGE: 'UNREAD_MESSAGE',
    LUCKYWHEELLANDING_TNC: 'LUCKYWHEELLANDING_TNC',
    COMING_SOON: 'COMING_SOON',
    DEPOSIT_METHOD_CONFIRMATION: 'DEPOSIT_METHOD_CONFIRMATION',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    DOWNLOAD: 'DOWNLOAD',
};

export const SGROUP = ['096', '96b', '001', '96c'];
export const REWARD_TYPE = {
    FREE_SPIN_SETTING: 'FREE_SPIN_SETTING',
    FREE_SPIN: 'FREE_SPIN',
};
export const unauthorizedMissionName = ['LOGIN', 'DAILY_LOGIN', 'LOGIN_APP'];

export const FILTER_MONTH_TYPE = {
    ALL: 'ALL',
    TODAY: 'TODAY',
    THIS_WEEK: 'THIS_WEEK',
    LAST_WEEK: 'LAST_WEEK',
    THIS_MONTH: 'THIS_MONTH',
    LAST_MONTH: 'LAST_MONTH',
    SIX_MONTHS: 'SIX_MONTHS',
};

export const BLOG_BANNER_TYPE = {
    BANNER_WEB: 'BANNER_WEB',
    BANNER_MOBILE: 'BANNER_MOBILE',
    SUB_IMAGE: 'SUB_IMAGE',
};

export const LINK_PREFIX = {
    FOLLOWUSEMAIL: 'mailto:',
    FOLLOWUSPHONE: 'tel:',
};

export const TUTORIAL_GUIDE_TYPE = {
    deposit: {
        B: 'deposit-guide-bankTransfer',
        QP: 'deposit-guide-quickPay',
        CT: 'deposit-guide-crypto',
    },
    withdraw: {
        B: 'withdrawal-guide-bankTransfer',
        CT: 'withdrawal-guide-crypto',
        WT: 'withdrawal-guide-wireTransfer',
    },
};

export const ANNOUNCEMENT_FREQUENCY_TYPE = {
    ALWAYS: 'always',
};

export const DEPOSIT_PRODUCT_BANNER_PREFIX = 'DS';

export const VIP_MEMBER_RULES = {
    VALID_BET_POINT: 'VALID_BET_POINT',
    DEPOSIT_POINT: 'DEPOSIT_POINT',
    VALID_BET_AND_DEPOSIT_POINT: 'VALID_BET_AND_DEPOSIT_POINT',
    VALID_BET_OR_DEPOSIT_POINT: 'VALID_BET_OR_DEPOSIT_POINT',
};

export const PROVIDER_URL = {
    SPS: 'https://fitboz.com',
};

export const FOLLOW_US_SET = new Set([
    'Facebook',
    'Youtube',
    'Instagram',
    'Twitter',
    'FOLLOWUSLINE',
    'Tiktok',
    'Zalo',
    'FOLLOWUSWHATSAPP',
    'FOLLOWUSTELEGRAM',
    'Pinterest',
    'Reddit',
    'FOLLOWUSCSKH',
    'FOLLOWUSEMAIL',
    'FOLLOWUSPHONE',
    'FOLLOWUSFEEDBACK',
    'FOLLOWUSMESSENGER',
    'FOLLOWUSTRUSTPILOT',
    'FOLLOWUSLINKEDIN',
    'contactWithSeq',
]);

export const CONTACT_NAME_MAP = {
    BasicDetailsTwitter: 'Twitter',
    BasicDetailsInstagram: 'Instagram',
    'Line 2': 'Line',
};

export const HIDE_FOOTER = {
    mobile: ['/contact-us', '/info-centre', '/myaccount'],
};
